import type { Setup } from "features/setups/types";
import { convertToBooleanSwitch } from "util/transformers";
import { BaseSetupValue, type BooleanValue, type ISetupValue } from "../types";

export class BooleanSetupValue extends BaseSetupValue<BooleanValue> implements ISetupValue<BooleanValue> {
    public deserialize(setupValue: Setup<string>['setupValue']): BooleanValue {
       return convertToBooleanSwitch(Number(setupValue));
    }

    public serialize() {
        return String(this.value);
    }
}
